import { render, staticRenderFns } from "./bogus.vue?vue&type=template&id=3f3399b6&scoped=true&"
import script from "./bogus.vue?vue&type=script&lang=js&"
export * from "./bogus.vue?vue&type=script&lang=js&"
import style0 from "./bogus.vue?vue&type=style&index=0&id=3f3399b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3399b6",
  null
  
)

export default component.exports